module.exports = __webpack_public_path__ + "img/advantage4.caef3d3c.png";